export const SAVE_ALL_USERS = 'SAVE_ALL_USERS'
export const SAVE_USER = 'SAVE_USER'
